<div class="w-full h-full p-1">
  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
    <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
    <p-dialog [draggable]="false" [(visible)]="configMissing" [closable]="false" appendTo="self">
      <i class="pi pi-exclamation-circle pr-1"></i> <label>{{ disabledMessage }}</label>
      <br />
      <br />
    </p-dialog>

    @if (designFactorsForm) {
      <form [formGroup]="designFactorsForm" class="w-full">
        <div class="flex flex-wrap gap-2 m-2">

          <!-- Pipe Section -->
          <div class="flex-1">
            <p-fieldset legend="Pipe" class="flex flex-col flex-grow-0 flex-shrink-0 basis-[150px]">

              <div class="flex flex-col mb-2">
                <label for="barlowBurst">Barlow Burst</label>
                <app-validated-number-input
                  [id]="'barlowBurst'"
                  [control]="control('barlowBurst')"
                  [value]="control('barlowBurst').value"
                  [validation]="{ min: 0.1, max: 10 }"
                ></app-validated-number-input>
              </div>

              <div class="flex flex-col mb-2">
                <label for="apiCollapse">API Collapse</label>
                <app-validated-number-input
                  [id]="'apiCollapse'"
                  [control]="control('apiCollapse')"
                  [value]="control('apiCollapse').value"
                  [validation]="{ min: 0.1, max: 10 }"
                ></app-validated-number-input>
              </div>

              <div class="flex flex-col mb-2">
                <label for="pureTension">Pure Tension</label>
                <app-validated-number-input
                  [id]="'pureTension'"
                  [control]="control('pureTension')"
                  [value]="control('pureTension').value"
                  [validation]="{ min: 0.1, max: 10 }"
                ></app-validated-number-input>
              </div>

              <div class="flex flex-col mb-2">
                <label for="pureCompression">Pure Compression</label>
                <app-validated-number-input
                  [id]="'pureCompression'"
                  [control]="control('pureCompression')"
                  [value]="control('pureCompression').value"
                  [validation]="{ min: 0.1, max: 10 }"
                ></app-validated-number-input>
              </div>

              <div class="flex flex-col mb-2">
                <label for="vonMisesBurst">Von Mises Burst</label>
                <app-validated-number-input
                  [id]="'vonMisesBurst'"
                  [control]="control('vonMisesBurst')"
                  [value]="control('vonMisesBurst').value"
                  [validation]="{ min: 0.1, max: 10 }"
                ></app-validated-number-input>
              </div>

              <div class="flex flex-col mb-2">
                <label for="vonMisesCollapse">Von Mises Collapse</label>
                <app-validated-number-input
                  [id]="'vonMisesCollapse'"
                  [control]="control('vonMisesCollapse')"
                  [value]="control('vonMisesCollapse').value"
                  [validation]="{ min: 0.1, max: 10 }"
                ></app-validated-number-input>
              </div>
            </p-fieldset>
          </div>

          <!-- Connection Section -->
          <div class="flex-1">
            <p-fieldset legend="Connection" class="flex flex-col flex-grow-0 flex-shrink-0 basis-[150px]">
              <div [formGroup]="connection">

                <div class="flex flex-col mb-2">
                  <label for="burst">Burst/Leak</label>
                  <app-validated-number-input
                    [id]="'conBurstLeak'"
                    [control]="connectionControl('burstLeak')"
                    [value]="connectionControl('burstLeak').value"
                    [validation]="{ min: 0.1, max: 10 }"
                  ></app-validated-number-input>
                </div>

                <div class="flex flex-col mb-2">
                  <label for="collapse">Collapse/Leak</label>
                  <app-validated-number-input
                    [id]="'conCollapse'"
                    [control]="connectionControl('collapse')"
                    [value]="connectionControl('collapse').value"
                    [validation]="{ min: 0.1, max: 10 }"
                  ></app-validated-number-input>
                </div>

                <div class="flex flex-col mb-2">
                  <label for="tension">Tension</label>
                  <app-validated-number-input
                    [id]="'conTension'"
                    [control]="connectionControl('tension')"
                    [value]="connectionControl('tension').value"
                    [validation]="{ min: 0.1, max: 10 }"
                  ></app-validated-number-input>
                </div>

                <div class="flex flex-col mb-2">
                  <label for="compression">Compression</label>
                  <app-validated-number-input
                    [id]="'compression'"
                    [control]="connectionControl('compression')"
                    [value]="connectionControl('compression').value"
                    [validation]="{ min: 0.1, max: 10 }"
                  ></app-validated-number-input>
                </div>

                <div class="flex flex-col mb-2">
                  <label for="envelopeBurst">CDE Burst</label>
                  <app-validated-number-input
                    [id]="'envelopeBurst'"
                    [control]="connectionControl('envelopeBurst')"
                    [value]="connectionControl('envelopeBurst').value"
                    [validation]="{ min: 0.1, max: 10 }"
                  ></app-validated-number-input>
                </div>

                <div class="flex flex-col mb-2">
                  <label for="envelopeCollapse">CDE Collapse</label>
                  <app-validated-number-input
                    [id]="'envelopeCollapse'"
                    [control]="connectionControl('envelopeCollapse')"
                    [value]="connectionControl('envelopeCollapse').value"
                    [validation]="{ min: 0.1, max: 10 }"
                  ></app-validated-number-input>
                </div>
              </div>
            </p-fieldset>
          </div>
        </div>
      </form>
    }
  </p-scrollPanel>
  </app-tool-loader>
</div>